import RichTextA11yWrapper from 'components/helpers/RichTextA11yWrapper';
import { RecentNetworkAnnouncementsProps } from './RecentNetworkAnnouncementsTypes';
import { classnames } from 'tailwindcss-classnames';

const Anonymous = ({ fields }: RecentNetworkAnnouncementsProps): JSX.Element => {
  if (!fields) {
    return <></>;
  }

  return (
    <div
      className={classnames(
        'rounded-[18px]',
        'bg-white',
        'theme-white-nrc',
        'py-[24px]',
        'px-[16px]',
        'text-body',
        'leading-2',
        'font-medium',
        'recentnews-annonymousUserContent'
      )}
    >
      <RichTextA11yWrapper className={classnames('rte')} field={fields.anonymousUserContent} />
    </div>
  );
};

export default Anonymous;
